import PropTypes from 'prop-types'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isArray } from 'lodash-es'
import { klass } from 'utils'

/**
 *
 * @param value
 * @param setter
 * @param className
 * @param min
 * @param max
 * @param step
 * @param disabled
 * @param size
 * @param prependText {string|object}
 * @param appendText {string|ReactElementLike|string[]} Allows a single string, element, or an array of [singular, plural] forms
 * @param props
 * @returns {*}
 * @constructor
 */
export default function NumberSpinner({
	value, setter, className,
	min = null, max = null, step = 1, disabled = false,
	size = null, prependText = '', appendText = '',
	...props
}) {
	const dec = () => (value > min || min == null) && setter(value - step)
	const inc = () => (value < max || max == null) && setter(value + step)

	const append = !appendText? null :
		!isArray(appendText)? appendText :
			(value == 1? appendText[0] : appendText[1])

	return (
		<InputGroup size={size} {...klass('number-spinner', className)}>
			<InputGroup.Prepend>
				{prependText && <InputGroup.Text>{prependText}</InputGroup.Text>}
				<Button variant="secondary" onClick={dec} disabled={disabled || (min != null && value <= min)}>
					<FontAwesomeIcon icon="minus"/>
				</Button>
			</InputGroup.Prepend>

			<Form.Control type="number" {...{min, max, value, disabled}} onChange={e => setter(e.target.value)} {...props}/>

			<InputGroup.Append>
				<Button variant="secondary" onClick={inc} disabled={disabled || (max != null && value >= max)}>
					<FontAwesomeIcon icon="plus"/>
				</Button>
				{append && <InputGroup.Text>{append}</InputGroup.Text>}
			</InputGroup.Append>
		</InputGroup>
	)
}

NumberSpinner.propTypes = {
	value      : PropTypes.number.isRequired,
	setter     : PropTypes.func.isRequired,
	className  : PropTypes.string,
	min        : PropTypes.number,
	max        : PropTypes.number,
	step       : PropTypes.number,
	disabled   : PropTypes.bool,
	size       : PropTypes.oneOf(['sm', 'lg']),
	prependText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	appendText : PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.string)]),
}
